export const GET_BIKE_MODELS_REQUEST = 'GET_BIKE_MODELS_REQUEST';
export const GET_BIKE_MODELS_REQUEST_SUCCESS = 'GET_BIKE_MODELS_REQUEST_SUCCESS';
export const GET_BIKE_MODELS_REQUEST_FAILURE = 'GET_BIKE_MODELS_REQUEST_FAILURE';

export const CHANGE_BIKE_MODEL_REQUEST = 'CHANGE_BIKE_MODEL_REQUEST';
export const CHANGE_BIKE_MODEL_REQUEST_SUCCESS = 'CHANGE_BIKE_MODEL_REQUEST_SUCCESS';
export const CHANGE_BIKE_MODEL_REQUEST_FAILURE = 'CHANGE_BIKE_MODEL_REQUEST_FAILURE';

export const CHANGE_BIKE_MODEL_LIST_REQUEST = 'CHANGE_BIKE_MODEL_LIST_REQUEST';
export const CHANGE_BIKE_MODEL_LIST_REQUEST_SUCCESS = 'CHANGE_BIKE_MODEL_LIST_REQUEST_SUCCESS';
export const CHANGE_BIKE_MODEL_LIST_REQUEST_FAILURE = 'CHANGE_BIKE_MODEL_LIST_REQUEST_FAILURE';

export const SEARCH_BIKE_MODEL_REQUEST = 'SEARCH_BIKE_MODEL_REQUEST';
export const SEARCH_BIKE_MODEL_REQUEST_SUCCESS = 'SEARCH_BIKE_MODEL_REQUEST_SUCCESS';
export const SEARCH_BIKE_MODEL_REQUEST_FAILURE = 'SEARCH_BIKE_MODEL_REQUEST_FAILURE';

export const SEARCH_BIKE_VARIANT_REQUEST = 'SEARCH_BIKE_VARIANT_REQUEST';
export const SEARCH_BIKE_VARIANT_REQUEST_SUCCESS = 'SEARCH_BIKE_VARIANT_REQUEST_SUCCESS';
export const SEARCH_BIKE_VARIANT_REQUEST_FAILURE = 'SEARCH_BIKE_VARIANT_REQUEST_FAILURE';

export const SEARCH_BIKE_REQUEST = 'SEARCH_BIKE_REQUEST';
export const SEARCH_BIKE_REQUEST_SUCCESS = 'SEARCH_BIKE_REQUEST_SUCCESS';
export const SEARCH_BIKE_REQUEST_FAILURE = 'SEARCH_BIKE_REQUEST_FAILURE';

export const SEARCH_HC_REQUEST = 'SEARCH_HC_REQUEST';
export const SEARCH_HC_SUCCESS = 'SEARCH_HC_SUCCESS';
export const SEARCH_HC_FAILURE = 'SEARCH_HC_FAILURE';

export const FILTER_SEARCH_REQUEST = 'FILTER_SEARCH_REQUEST';
export const FILTER_SEARCH_REQUEST_SUCCESS = 'FILTER_SEARCH_REQUEST_SUCCESS';
export const FILTER_SEARCH_REQUEST_FAILURE = 'FILTER_SEARCH_REQUEST_FAILURE';

export const COUNT_BIKE_MODELS_REQUEST = 'COUNT_BIKE_MODELS_REQUEST';
export const COUNT_BIKE_MODELS_REQUEST_SUCCESS = 'COUNT_BIKE_MODELS_REQUEST_SUCCESS';
export const COUNT_BIKE_MODELS_REQUEST_FAILURE = 'COUNT_BIKE_MODELS_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/constants/bike_model.constants.js